/** Category shortcuts and a product's actual return-to-results context. No tracking or cart writes. */
const RESULT_KEY = 'pusa_navigation_results_v1';
const NOTICE_KEY = 'pusa_navigation_notice_v1';
const MAX_AGE = 30 * 60 * 1000;
const SHOE_SIZE_KEY = 'filter.v.option.shoe size';

export function toggleShoeSizeURL(currentHref, aliases) {
  const url = new URL(currentHref);
  const selected = url.searchParams.getAll(SHOE_SIZE_KEY);
  const remove = aliases.some(value => selected.includes(value));
  const next = remove ? selected.filter(value => !aliases.includes(value)) : [...new Set([...selected, ...aliases])];
  url.searchParams.delete(SHOE_SIZE_KEY);
  next.forEach(value => url.searchParams.append(SHOE_SIZE_KEY, value));
  url.searchParams.delete('page');
  return url.pathname + url.search;
}

// Verified smart-collection rules; refresh from docs/navigation-guidance-20261001 after rule changes.
const RACKET_CONTEXTS = {
  "beginners": {"filter.p.m.custom.level":["Beginner"]},
  "best-padel-rackets-for-beginners": {"filter.p.m.custom.level":["Beginner"],"filter.v.availability":["1"]},
  "rackets-for-intermediate-players": {"filter.p.m.custom.level":["Intermediate"],"filter.v.availability":["1"]},
  "level-advanced-pro": {"filter.p.m.custom.level":["Advanced","Pro"]},
  "round-shaped-rackets": {"filter.p.m.custom.shape":["Round"]},
  "teardrop-shaped-rackets": {"filter.p.m.custom.shape":["Teardrop","Inverted Teardrop","Hybrid"]},
  "diamond-shaped-rackets": {"filter.p.m.custom.shape":["Diamond"]},
  "babolat-power-rackets": {"filter.p.vendor":["Babolat"],"filter.p.m.custom.type_of_play":["Power"]},
  "adidas-power-rackets": {"filter.p.vendor":["Adidas"],"filter.p.m.custom.type_of_play":["Power"]},
  "adidas-control-rackets": {"filter.p.vendor":["Adidas"],"filter.p.m.custom.type_of_play":["Control"]},
  "adidas-all-around-rackets": {"filter.p.vendor":["Adidas"],"filter.p.m.custom.type_of_play":["All around"]},
  "adidas-defensive-rackets": {"filter.p.vendor":["Adidas"],"filter.p.m.custom.type_of_play":["Defensive"]},
  "adidas-lightweight-rackets": {"filter.p.vendor":["Adidas"],"filter.p.m.custom.weight":["360g or less"]},
  "babolat-versatile-rackets": {"filter.p.vendor":["Babolat"],"filter.p.m.custom.type_of_play":["Versatile"]},
  "babolat-all-around-rackets": {"filter.p.vendor":["Babolat"],"filter.p.m.custom.type_of_play":["All around"]},
  "babolat-aggressive-rackets": {"filter.p.vendor":["Babolat"],"filter.p.m.custom.type_of_play":["Aggresive"]},
  "babolat-lightweight-rackets": {"filter.p.vendor":["Babolat"],"filter.p.m.custom.weight":["360g or less"]},
  "bullpadel-power-rackets": {"filter.p.vendor":["Bullpadel"],"filter.p.m.custom.type_of_play":["Power"]},
  "bullpadel-versatile-rackets": {"filter.p.vendor":["Bullpadel"],"filter.p.m.custom.type_of_play":["Versatile"]},
  "bullpadel-all-around-rackets": {"filter.p.vendor":["Bullpadel"],"filter.p.m.custom.type_of_play":["All around"]},
  "bullpadel-aggressive-rackets": {"filter.p.vendor":["Bullpadel"],"filter.p.m.custom.type_of_play":["Aggresive"]},
  "bullpadel-lightweight-rackets": {"filter.p.vendor":["Bullpadel"],"filter.p.m.custom.weight":["360g or less"]},
  "head-power-rackets": {"filter.p.vendor":["Head"],"filter.p.m.custom.type_of_play":["Power"]},
  "head-control-rackets": {"filter.p.vendor":["Head"],"filter.p.m.custom.type_of_play":["Control"]},
  "head-versatile-rackets": {"filter.p.vendor":["Head"],"filter.p.m.custom.type_of_play":["Versatile"]},
  "head-all-around-rackets": {"filter.p.vendor":["Head"],"filter.p.m.custom.type_of_play":["All around"]},
  "head-aggressive-rackets": {"filter.p.vendor":["Head"],"filter.p.m.custom.type_of_play":["Aggresive"]},
  "head-lightweight-rackets": {"filter.p.vendor":["Head"],"filter.p.m.custom.weight":["360g or less"]},
  "nox-power-rackets": {"filter.p.vendor":["Nox"],"filter.p.m.custom.type_of_play":["Power"]},
  "nox-control-rackets": {"filter.p.vendor":["Nox"],"filter.p.m.custom.type_of_play":["Control"]},
  "nox-versatile-rackets": {"filter.p.vendor":["Nox"],"filter.p.m.custom.type_of_play":["Versatile"]},
  "nox-all-around-rackets": {"filter.p.vendor":["Nox"],"filter.p.m.custom.type_of_play":["All around"]},
  "siux-power-rackets": {"filter.p.vendor":["Siux"],"filter.p.m.custom.type_of_play":["Power"]},
  "siux-versatile-rackets": {"filter.p.vendor":["Siux"],"filter.p.m.custom.type_of_play":["Versatile"]},
  "siux-all-around-rackets": {"filter.p.vendor":["Siux"],"filter.p.m.custom.type_of_play":["All around"]},
  "wilson-power-rackets": {"filter.p.vendor":["Wilson"],"filter.p.m.custom.type_of_play":["Power"]},
  "wilson-control-rackets": {"filter.p.vendor":["Wilson"],"filter.p.m.custom.type_of_play":["Control"]},
  "wilson-versatile-rackets": {"filter.p.vendor":["Wilson"],"filter.p.m.custom.type_of_play":["Versatile"]},
  "wilson-all-around-rackets": {"filter.p.vendor":["Wilson"],"filter.p.m.custom.type_of_play":["All around"]},
  "wilson-lightweight-rackets": {"filter.p.vendor":["Wilson"],"filter.p.m.custom.weight":["360g or less"]}
};
// Only the native racket facets verified as enabled; a metafield/rule alone is not a working storefront filter.
const RACKET_FIELDS = ['level','type_of_play','shape','balance','pro'].map(key => `filter.p.m.custom.${key}`);
const RACKET_DIMENSIONS = {
  level: ['filter.p.m.custom.level'],
  need: ['filter.p.m.custom.type_of_play', 'filter.p.m.custom.racket_tag'],
  shape: ['filter.p.m.custom.shape'],
  weight: ['filter.p.m.custom.weight'],
  brand: ['filter.p.vendor'],
  price: ['filter.v.price.gte', 'filter.v.price.lte'],
  junior: RACKET_FIELDS
};

export function mergeNavigationURL(targetHref, currentHref, group, all = false, implicitVendor = '', dimension = '', mode = 'refine') {
  const current = new URL(currentHref);
  const target = new URL(targetHref, current);
  if (target.origin !== current.origin) return { href: target.href, sizeCleared: false };
  // Main categories are browse destinations, not an invisible intersection with the
  // previous category. Keep destination-authored filters and sorting, but start a new list.
  if (group === 'rackets' && (mode === 'browse' || all)) {
    if (!target.searchParams.has('sort_by') && current.searchParams.has('sort_by')) {
      target.searchParams.set('sort_by', current.searchParams.get('sort_by'));
    }
    target.searchParams.delete('page');
    target.searchParams.delete('after');
    return { href: target.pathname + target.search, sizeCleared: false };
  }
  const rangeChanged = group === 'shoes' && target.pathname !== current.pathname;
  const preserve = new Set(['filter.p.vendor', 'filter.v.availability', 'filter.v.price.gte', 'filter.v.price.lte', 'sort_by']);
  const sourceFacts = group === 'rackets' && !all ? RACKET_CONTEXTS[current.pathname.split('/').pop()] || {} : {};
  const targetFacts = group === 'rackets' ? RACKET_CONTEXTS[target.pathname.split('/').pop()] || {} : {};
  const replaced = new Set(group === 'rackets' ? [...(RACKET_DIMENSIONS[dimension] || []), ...Object.keys(targetFacts)] : []);
  if (group === 'rackets') RACKET_FIELDS.forEach(key => preserve.add(key));
  if (group === 'shoes' && !rangeChanged) preserve.add('filter.v.option.shoe size');
  // Destination constraints win. Remove page/cursor; preserve multiple values in other dimensions.
  for (const key of preserve) {
    if (target.searchParams.has(key) || replaced.has(key)) continue;
    const selected = current.searchParams.has(key) ? current.searchParams.getAll(key) : sourceFacts[key] || [];
    for (const value of new Set(selected)) target.searchParams.append(key, value);
  }
  // A dedicated brand collection carries this constraint in its membership, not its query string.
  if (implicitVendor && !replaced.has('filter.p.vendor') && !target.searchParams.has('filter.p.vendor')) target.searchParams.set('filter.p.vendor', implicitVendor);
  if (all && group === 'sale') target.searchParams.delete('filter.p.product_type');
  target.searchParams.delete('page');
  target.searchParams.delete('after');
  const sizeCleared = rangeChanged && [...current.searchParams.keys()].some(k => /^filter\.v\.option\.(shoe size|size)$/i.test(k));
  return { href: target.pathname + target.search, sizeCleared };
}

export function validResultsContext(record, productURL, now = Date.now()) {
  if (!record || typeof record.href !== 'string' || typeof record.product !== 'string' || !Number.isFinite(record.savedAt)) return false;
  if (now - record.savedAt > MAX_AGE || record.savedAt > now) return false;
  try {
    const product = new URL(productURL);
    const result = new URL(record.href, product);
    return result.origin === product.origin && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(collections\/|search(?:$|\/))/.test(result.pathname)
      && record.product === product.pathname && Number.isFinite(record.scroll) && record.scroll >= 0;
  } catch { return false; }
}

export function resultsURLForCard(currentHref, page) {
  const url = new URL(currentHref);
  const number = Number(page);
  if (Number.isInteger(number) && number > 1) url.searchParams.set('page', String(number));
  else if (number === 1) url.searchParams.delete('page');
  return url.pathname + url.search;
}

export function resultScrollTarget(record, currentScroll, cardTop) {
  if (Number.isFinite(record.cardOffset) && Number.isFinite(cardTop)) return Math.max(0, currentScroll + cardTop - record.cardOffset);
  return Math.max(0, record.scroll);
}

export function legacyShoeDestination(currentHref, destinations) {
  const current = new URL(currentHref);
  if (!/\/collections\/padel-shoes\/?$/.test(current.pathname)) return null;
  const keys = ['filter.p.m.custom.gender', 'filter.p.m.custom.for_whom'];
  const ranges = [...new Set(keys.flatMap(key => current.searchParams.getAll(key)))];
  if (ranges.length !== 1 || !['Men', 'Women'].includes(ranges[0]) || !destinations[ranges[0]]) return null;
  const merged = mergeNavigationURL(destinations[ranges[0]], current.href, 'shoes');
  const target = new URL(merged.href, current);
  if (target.origin !== current.origin || target.pathname === current.pathname) return null;
  return merged;
}

function boot() {
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch { /* navigation still works */ } };
  const clear = key => { try { sessionStorage.removeItem(key); } catch { /* storage may be disabled */ } };
  const destinations = Object.fromEntries([...document.querySelectorAll('[data-navigation-shoe-range]')].map(link => [link.dataset.navigationShoeRange, link.getAttribute('href')]));
  const legacy = legacyShoeDestination(location.href, destinations);
  if (legacy) {
    if (legacy.sizeCleared) write(NOTICE_KEY, { path: new URL(legacy.href, location.origin).pathname, text: 'Choose your size for this shoe range. The old size filter has been cleared.' });
    location.replace(legacy.href);
    return;
  }
  let racketRoutes = [];
  try { racketRoutes = JSON.parse(document.querySelector('[data-navigation-racket-routes]')?.textContent || '[]').sort((a,b) => new URL(b.url, location.origin).searchParams.size - new URL(a.url, location.origin).searchParams.size); } catch { /* canonical links remain usable */ }
  const routeFor = href => {
    try { const url = new URL(href, location.origin); return racketRoutes.find(route => { const target = new URL(route.url, location.origin); return url.origin === target.origin && url.pathname === target.pathname && [...target.searchParams].every(([key,value]) => url.searchParams.getAll(key).includes(value)); }); } catch { return null; }
  };
  const hydrate = () => {
    const racketContext = document.querySelector('main [data-navigation-group="rackets"]');
    if (racketContext) document.querySelectorAll('header-component a[href]').forEach(link => {
      const route = routeFor(link.dataset.navigationOriginal || link.getAttribute('href'));
      if (!route) return;
      link.dataset.navigationLink = '';
      link.dataset.navigationGroup = 'rackets';
      link.dataset.navigationDimension = route.dimension;
      if (route.all) link.dataset.navigationAll = '';
    });
    document.querySelectorAll('collection-filter-chips[mode="brand"][data-navigation-group] .cfc-chip').forEach(link => {
      link.setAttribute('data-navigation-link', '');
      if (link.classList.contains('cfc-chip--all')) link.setAttribute('data-navigation-all', '');
    });
    document.querySelectorAll('[data-navigation-link]').forEach(link => {
      link.dataset.navigationOriginal ||= link.getAttribute('href');
      const context = link.closest('[data-navigation-group]');
      const group = link.dataset.navigationGroup || context?.dataset.navigationGroup;
      const mode = group === 'rackets' && !link.closest('collection-filter-chips[mode="brand"]') ? 'browse' : 'refine';
      const merged = mergeNavigationURL(link.dataset.navigationOriginal, location.href, group, link.hasAttribute('data-navigation-all'), context?.dataset.navigationVendor || (group === 'rackets' ? racketContext?.dataset.navigationVendor : ''), link.dataset.navigationDimension || routeFor(link.dataset.navigationOriginal)?.dimension || '', mode);
      const detail = document.querySelector('results-list[data-cll-variant="detail"][data-cll-view]');
      const destination = new URL(merged.href, location.origin);
      if (detail?.dataset.cllView && (detail.dataset.cllView !== 'racket-detail' || link.closest('.cfc-section, collection-breadcrumb')) && destination.origin === location.origin && /\/collections\/[^/]+\/?$/.test(destination.pathname)) {
        destination.searchParams.set('view', detail.dataset.cllView);
        if (detail.dataset.cllView !== 'racket-detail' && detail.dataset.cllTheme) destination.searchParams.set('preview_theme_id', detail.dataset.cllTheme);
      }
      link.href = destination.href;
      link.dataset.navigationSizeCleared = String(merged.sizeCleared);
      const target = new URL(link.dataset.navigationOriginal, location.origin);
      const current = new URL(location.href);
      const isDetailPreview = !!link.closest('.cfc-section[data-cfc-visual="detail"]');
      const presentationKeys = new Set(isDetailPreview ? ['view', 'preview_theme_id', 'pb'] : []);
      const selected = target.pathname === current.pathname && [...target.searchParams].every(([k,v]) => presentationKeys.has(k) || current.searchParams.getAll(k).includes(v))
        && !(link.hasAttribute('data-navigation-all') && group === 'sale' && current.searchParams.has('filter.p.product_type'));
      link.classList.toggle('cfc-chip--active', selected);
      if (selected) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
    });
    // Never expose ambiguous audience as a racket eligibility facet. The catalog and finder are unchanged.
    document.querySelectorAll('[name="filter.p.m.custom.for_whom"], [name="filter.p.product_type"]').forEach(input => {
      const key = input.name;
      const group = document.querySelector('[data-navigation-group]')?.dataset.navigationGroup;
      const active = document.querySelector(`input[name="${key}"]:checked`);
      if (!active && ((key.endsWith('for_whom') && ['rackets','shoes'].includes(group)) || (key.endsWith('product_type') && ['rackets','shoes','bags','balls'].includes(group)))) {
        input.closest('details')?.setAttribute('hidden', '');
      }
    });
  };
  hydrate();
  document.addEventListener('filter:update', hydrate);
  const header = document.querySelector('header-component');
  if (header) {
    new MutationObserver(hydrate).observe(header, { childList: true, subtree: true });
    header.addEventListener('toggle', hydrate, true);
  }
  // Re-rendered facets and appended infinite-scroll pages both update the visible URL state.
  const results = document.querySelector('results-list');
  let lastURL = location.pathname + location.search;
  if (results) new MutationObserver(() => { hydrate(); lastURL = location.pathname + location.search; }).observe(document.querySelector('main'), { childList: true, subtree: true });
  document.addEventListener('filter:update', () => { lastURL = location.pathname + location.search; });
  window.addEventListener('popstate', () => {
    // Stock facets push history but don't restore their DOM on popstate. Reload the selected URL.
    // The premium collection controller restores its own rendered Back/Forward state.
    if (document.documentElement.hasAttribute('data-collection-navigation')) return;
    if (results && location.pathname + location.search !== lastURL) location.reload();
  });
  const recordNavigation = event => {
    const link = event.target.closest?.('a');
    if (!link || event.defaultPrevented || ![0,1].includes(event.button)) return;
    if (link.hasAttribute('data-navigation-size-link') && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const form = link.closest('facets-form-component');
      if (form?.updateFiltersByURL) {
        event.preventDefault();
        let aliases;
        try { aliases = JSON.parse(link.dataset.navigationSizeValues || 'null'); } catch { /* use the real anchor */ }
        const target = new URL(Array.isArray(aliases) ? toggleShoeSizeURL(location.href, aliases) : link.href, location.origin);
        target.searchParams.delete('page');
        // Commit native form state before the async section response, so the next tap cannot lose it.
        document.querySelectorAll('facets-form-component form').forEach(nativeForm => {
          if (!nativeForm.querySelector('[data-navigation-size-link]')) return;
          nativeForm.querySelectorAll(`input[type="hidden"][name="${SHOE_SIZE_KEY}"]`).forEach(input => input.remove());
          target.searchParams.getAll(SHOE_SIZE_KEY).forEach(value => {
            const input = document.createElement('input');
            input.type = 'hidden'; input.name = SHOE_SIZE_KEY; input.value = value;
            nativeForm.append(input);
          });
        });
        form.updateFiltersByURL(target.pathname + target.search);
      }
      return;
    }
    if (link.dataset.navigationSizeCleared === 'true') write(NOTICE_KEY, { path: new URL(link.href).pathname, text: 'Size cleared because you changed shoe ranges. Choose your size for this range.' });
    if (!link.closest('#ResultsList') || !link.href.includes('/products/')) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin) return;
    const card = link.closest('[data-page]');
    write(RESULT_KEY, { href: resultsURLForCard(location.href, card?.dataset.page), product: url.pathname, scroll: window.scrollY, cardId: card?.id, cardOffset: card?.getBoundingClientRect().top, savedAt: Date.now() });
  };
  document.addEventListener('click', recordNavigation, { capture: true });
  document.addEventListener('auxclick', recordNavigation, { capture: true });
  const back = document.querySelector('[data-navigation-return]');
  const record = read(RESULT_KEY);
  if (back && validResultsContext(record, location.href)) {
    back.href = record.href;
    back.textContent = '← Back to your results';
    back.addEventListener('click', () => write(RESULT_KEY, { ...record, restore: true }));
  }
  function restore() {
    const saved = read(RESULT_KEY);
    if (!saved || saved.href !== location.pathname + location.search || Date.now() - saved.savedAt > MAX_AGE) return;
    const isBack = performance.getEntriesByType('navigation')[0]?.type === 'back_forward';
    if (saved.restore || isBack) {
      requestAnimationFrame(() => {
        const card = saved.cardId ? document.getElementById(saved.cardId) : null;
        window.scrollTo({ top: resultScrollTarget(saved, window.scrollY, card?.getBoundingClientRect().top), behavior: 'instant' });
      });
      write(RESULT_KEY, { ...saved, restore: false });
    }
  }
  window.addEventListener('pageshow', restore);
  if (document.readyState === 'complete') restore(); else window.addEventListener('load', restore, { once: true });
  const showNotice = () => {
    const notice = read(NOTICE_KEY);
    const noticeElement = document.querySelector('[data-navigation-notice]');
    if (notice?.path === location.pathname && noticeElement) { noticeElement.textContent = notice.text; noticeElement.hidden = false; clear(NOTICE_KEY); }
  };
  showNotice();
  document.addEventListener('collection:navigate', () => {
    hydrate();
    lastURL = location.pathname + location.search;
    showNotice();
  });
}

if (typeof document !== 'undefined' && document.body.hasAttribute('data-navigation-test')) boot();
